import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/storage";
import "firebase/functions";

const config = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJ_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
};
export const firebaseModule = firebase;
export const app = firebase.initializeApp(config);
export const auth = app.auth();
export const firestore = app.firestore();
export const db = app.database();
export const storage = firebase.storage();
export const functions = app.functions('europe-west1');

// if (location.hostname === "localhost") {
//   firebase.functions().useFunctionsEmulator('http://localhost:5001');
//   firestore.settings({
//     host: "localhost:8080",
//     ssl: false,
//   });
// }
